import React from "react"
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { TextField, Select, MenuItem, InputBase, FormControl, FormHelperText, ThemeProvider, InputAdornment, IconButton } from "@material-ui/core"
import Save from "../../../../Assets/img/svg/save.svg"
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { getSettingsFormat } from "../../../../actions/SettingsAction"
import Cancel from "../../../../Assets/img/svg/cancel.svg"
import image from "../../../../Assets/img/svg/Image.svg"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../Assets/jss/customStyle";
import $ from "jquery"
import moment from "moment"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Delete from "../../../../Assets/img/svg/delete.svg"
import axios from "axios";
import API from "../../../../helpers/endpointService"
import del from "../../../../Assets/img/svg/Del.svg";
import { VesselStatus, inspectionSystem } from "../../../Constants";
import { getShipTypeList, getStatusTypeList } from "../../../../actions/Lookup"
import {warningAlert,successAlert} from "../../../custom/alert"
import { successToast, errorToast } from "../../../../actions/CommonFunction";
import "./AddEditVP.css";

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);


class AddEditVP extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isMobile: false,
            menu: true,
            cancel: false,
            isEdit: false,
            isError1: false,
            isError2: false,
            isError3: false,
            isError4: false,
            isError5: false,
            isError6: false,
            isError7: false,
            isError8: false,
            isError9: false,
            isError10: false,
            isError11: false,
            isError12: false,
            isError13: false,
            isError14: false,
            isError15: false,
            isError16: false,
            isError17: false,
            isError18: false,
            isError19: false,
            isError20: false,
            isError21: false,
            isError22: false,
            isError23: false,
            isError24: false,
            ShipName: "",
            IMONumber: 0,
            addData: {
                "Id": 0,
                "ShipId": 0,
                "SectionId": 0,
                "InspectionId": 0,
                "PreviousName": "",
                "PortOfRegistry": "",
                "Status": "",
                "ShipType": 0,
                "Flag": "",
                "Class": "",
                "RegisteredOwner": "",
                "ManagementAS": "",
                "TechnicalManager": "",
                "ShipBuilder": "",
                "DeliveryDate": null,
                "DeadWeight": "",
                "GrossTonnage": "",
                "NetTonnage": "",
                "LengthOverall": "",
                "Breath": "",
                "Depth": "",
                "Summer": "",
                "CallSign": "",
                "Mmsi": "",
                "Teu": "",
                "LightWeight": "",
                "InspectionLocation": "",
                "IsDeleted": true,
                "CreatedBy": "",
                "ModifiedBy": "",
            }
        }
    };
    async componentDidMount() {
        const { dispatch } = this.props;
        await dispatch(getShipTypeList(VesselStatus.ShipType));
        await dispatch(getStatusTypeList(VesselStatus.Status));
        this.state.addData.ShipId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.ShipName = localStorage.getItem("ShipName");
        this.state.addData.IMONumber = parseInt(localStorage.getItem("IMONumber"));
        this.state.addData.InspectionId = parseInt(localStorage.getItem("InspectionId"));
        this.setState({})
        console.log(this.state.addData.ShipId)
        console.log(parseInt(localStorage.getItem("DashId")))
        if (parseInt(localStorage.getItem("DashId")) != null) {
            this.getshipinfo(localStorage.getItem("DashId"))
        }
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
        $(".vp-shiptype-select").change(function () {
            var selectedValue = $(this).val();
            localStorage.setItem("ShipType", parseInt(selectedValue));
        });
        $(".demo-customized-select").change(function () {
            var selectedValue = $(this).val();
            console.log(selectedValue, "sudar")
            localStorage.setItem("Status", selectedValue)
            if (selectedValue == "Completed") {
                $("#completeddate").addClass("d-block");
                $("#completeddate1").addClass("d-block");
                $("#completeddate").removeClass("d-none");
                $("#completeddate1").removeClass("d-none");
            } else {
                $("#completeddate").removeClass("d-block");
                $("#completeddate1").removeClass("d-block");
                $("#completeddate").addClass("d-none");
                $("#completeddate1").addClass("d-none");
            }
        });
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        this.props.dispatch({ type: "RICHTEXT", data: false });
        this.props.dispatch({ type: "RICHTEXT1", data: false });
        $("#VSP1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#VesselParticular1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#VesselParticular").addClass("d-none");
        $("#VesselParticular").removeClass("d-block");
        $("#VPL").removeClass("active-color")
        $("#VPT ").removeClass("fw-bolder")
    }
    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/shiplist`)
        }
    }

    AddCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate(`/shiplist`)
    };
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        } else {
            this.props.navigate("/sidebar");
        }
    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebar");
    };
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })

        }
    }
    resize1 = () => {
        $("#VSP1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#VesselParticular1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#VesselParticular").removeClass("d-none");
        $("#VesselParticular").addClass("d-block");
        $("#VPL").addClass("active-color");
        $("#VPT").addClass("fw-bolder");

    };
    getshipinfo = (data) => {
        const { dispatch } = this.props;
        let Inspection = parseInt(localStorage.getItem("InspectionId"))
        let Id = parseInt(data)
        console.log(Id)
        console.log(this.state.addData.ShipId)
        let apiUrl = `${API.Get_Vessel}?ShipId=${Id}&InspectionId=${Inspection}&SectionId=${inspectionSystem.Vesselparticulars}`;
        this.props.dispatch({ type: "SHOW_LOADER", data: true });
        axios.get(apiUrl)
            .then((response) => {
                if (response?.status === 200) {
                    console.log(response?.data)
                    if (response?.data.Id !== 0) {
                        console.log(response.data)
                        this.state.addData = response?.data;
                        this.setState({})
                        localStorage.setItem("ShipType", parseInt(response?.data.ShipType));
                        localStorage.setItem("Status", response?.data.Status);
                    }
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false });
                if (error?.response?.status === 401) {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false });
                }
            });
    };

    handleDateChange = (e, node) => {
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.cancel = true;
        this.setState({})
        if (e.target.value == "") {
            this.state.addData[node] = "";
            this.setState({});
        }
        else {
            this.state.addData[node] = e.target.value
            this.setState({});
        }
    };

    handleInputChange = (e, node) => {
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.cancel = true;
        if (node === "DeliveryDate" && e?.target?.value === "") {
            this.state.addData[node] = null;
            this.state.isError9 = true;
        } else if (node === "DeliveryDate") {
            this.state.addData[node] = e.target.value;
            this.state.isError9 = false;
        } else if (node === "ShipType") {
            this.state.addData[node] = e.target.value;
            this.state.isError11 = parseInt(e.target.value, 10) <= 0;
        } else {
            this.state.addData[node] = e.target.value;
        }
        this.setState({})
    };

    getDeliveryDateValue = () => {
        const { DeliveryDate } = this.state.addData;
        if (!DeliveryDate) {
            return "";
        }

        const formatted = moment(DeliveryDate).format("YYYY-MM-DD");
        if (formatted === "0001-00-01" || formatted.startsWith("0001")) {
            return "";
        }

        return formatted;
    };

    getDeliveryDateDisplay = () => {
        const value = this.getDeliveryDateValue();
        if (!value) {
            return "";
        }

        const convention = this.props.settings?.Convention || "DD/MM/YYYY";
        return moment(this.state.addData.DeliveryDate).format(convention);
    };

    getDeliveryDatePlaceholder = () => {
        const convention = this.props.settings?.Convention || "DD/MM/YYYY";
        const value = this.getDeliveryDateValue();

        if (!value) {
            return convention;
        }

        return moment(this.state.addData.DeliveryDate).format(convention);
    };

    Save = () => {
        const { ShipId, InspectionId, ShipType, DeliveryDate } = this.state.addData;
        const shipTypeValue = parseInt(ShipType, 10);
        const hasValidShipType = !Number.isNaN(shipTypeValue) && shipTypeValue > 0;
        const hasValidDeliveryDate = Boolean(this.getDeliveryDateValue());

        this.state.isError9 = !hasValidDeliveryDate;
        this.state.isError11 = !hasValidShipType;
        this.setState({});

        if (!hasValidShipType || !hasValidDeliveryDate) {
            return;
        }

        if (ShipId !== 0 && InspectionId !== 0 || ShipId !== undefined && InspectionId !== undefined) {
            // if (ManagementAS.trim() === "") {
            //     this.state.isError1 = true;
            //     this.state.addData.ManagementAS = this.state.addData.ManagementAS.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError1 = false;
            //     this.state.addData.ManagementAS = this.state.addData.ManagementAS.trim();
            //     this.setState({})
            // }
            // if (Breath.trim() === "") {
            //     this.state.isError2 = true;
            //     this.state.addData.Breath = this.state.addData.Breath.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError2 = false;
            //     this.state.addData.Breath = this.state.addData.Breath.trim();
            //     this.setState({})
            // }
            // if (PreviousName.trim() === "") {
            //     this.state.isError3 = true;
            //     this.state.addData.PreviousName = this.state.addData.PreviousName.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError3 = false;
            //     this.state.addData.PreviousName = this.state.addData.PreviousName.trim();
            //     this.setState({})
            // }
            // if (TechnicalManager.trim() === "") {
            //     this.state.isError4 = true;
            //     this.state.addData.TechnicalManager = this.state.addData.TechnicalManager.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError4 = false;
            //     this.state.addData.TechnicalManager = this.state.addData.TechnicalManager.trim();
            //     this.setState({})
            // }
            // if (Depth.trim() === "") {
            //     this.state.isError5 = true;
            //     this.state.addData.Depth = this.state.addData.Depth.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError5 = false;
            //     this.state.addData.Depth = this.state.addData.Depth.trim();
            //     this.setState({})
            // }
            // if (ShipBuilder.trim() === "") {
            //     this.state.isError6 = true;
            //     this.state.addData.ShipBuilder = this.state.addData.ShipBuilder.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError6 = false;
            //     this.state.addData.ShipBuilder = this.state.addData.ShipBuilder.trim();
            //     this.setState({})
            // }
            // if (Summer.trim() === "") {
            //     this.state.isError7 = true;
            //     this.state.addData.Summer = this.state.addData.Summer.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError7 = false;
            //     this.state.addData.Summer = this.state.addData.Summer.trim();
            //     this.setState({})
            // }
            // if (PortOfRegistry.trim() === "") {
            //     this.state.isError8 = true;
            //     this.state.addData.PortOfRegistry = this.state.addData.PortOfRegistry.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError8 = false;
            //     this.state.addData.PortOfRegistry = this.state.addData.PortOfRegistry.trim();
            //     this.setState({})
            // }
            // if (DeliveryDate === "") {
            //     this.state.isError9 = true;
            //     this.state.addData.DeliveryDate = this.state.addData.DeliveryDate;
            //     this.setState({})
            // }
            // else {
            //     this.state.isError9 = false;
            //     this.state.addData.DeliveryDate = this.state.addData.DeliveryDate;
            //     this.setState({})
            // }
            // if (CallSign.trim() === "") {
            //     this.state.isError10 = true;
            //     this.state.addData.CallSign = this.state.addData.CallSign.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError10 = false;
            //     this.state.addData.CallSign = this.state.addData.CallSign.trim();
            //     this.setState({})
            // }
            // if (ShipType === 0) {
            //     this.state.isError11 = true;
            //     this.state.addData.ShipType = parseInt(this.state.addData.ShipType);
            //     this.setState({})
            // }
            // else {
            //     this.state.isError11 = false;
            //     this.state.addData.ShipType = parseInt(this.state.addData.ShipType);
            //     this.setState({})
            // }
            // if (DeadWeight === "") {
            //     this.state.isError12 = true;
            //     this.state.addData.DeadWeight = this.state.addData.DeadWeight.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError12 = false;
            //     this.state.addData.DeadWeight = this.state.addData.DeadWeight.trim();
            //     this.setState({})
            // }
            // if (Mmsi.trim() === "") {
            //     this.state.isError13 = true;
            //     this.state.addData.Mmsi = this.state.addData.Mmsi.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError13 = false;
            //     this.state.addData.Mmsi = this.state.addData.Mmsi.trim();
            //     this.setState({})
            // }
            // if (Flag.trim() === "") {
            //     this.state.isError14 = true;
            //     this.state.addData.Flag = this.state.addData.Flag.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError14 = false;
            //     this.state.addData.Flag = this.state.addData.Flag.trim();
            //     this.setState({})
            // }
            // if (GrossTonnage === "") {
            //     this.state.isError15 = true;
            //     this.state.addData.GrossTonnage = this.state.addData.GrossTonnage.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError15 = false;
            //     this.state.addData.GrossTonnage = this.state.addData.GrossTonnage.trim();
            //     this.setState({})
            // }
            // if (Teu.trim() === "") {
            //     this.state.isError16 = true;
            //     this.state.addData.Teu = this.state.addData.Teu.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError16 = false;
            //     this.state.addData.Teu = this.state.addData.Teu.trim();
            //     this.setState({})
            // }
            // if (Class.trim() === "") {
            //     this.state.isError17 = true;
            //     this.state.addData.Class = this.state.addData.Class.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError17 = false;
            //     this.state.addData.Class = this.state.addData.Class.trim();
            //     this.setState({})
            // }
            // if (NetTonnage === "") {
            //     this.state.isError18 = true;
            //     this.state.addData.NetTonnage = this.state.addData.NetTonnage.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError18 = false;
            //     this.state.addData.NetTonnage = this.state.addData.NetTonnage.trim();
            //     this.setState({})
            // }
            // if (LightWeight.trim() === "") {
            //     this.state.isError19 = true;
            //     this.state.addData.LightWeight = this.state.addData.LightWeight.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError19 = false;
            //     this.state.addData.LightWeight = this.state.addData.LightWeight.trim();
            //     this.setState({})
            // }
            // if (RegisteredOwner.trim() === "") {
            //     this.state.isError20 = true;
            //     this.state.addData.RegisteredOwner = this.state.addData.RegisteredOwner.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError20 = false;
            //     this.state.addData.RegisteredOwner = this.state.addData.RegisteredOwner.trim();
            //     this.setState({})
            // }
            // if (LengthOverall.trim() === "") {
            //     this.state.isError21 = true;
            //     this.state.addData.LengthOverall = this.state.addData.LengthOverall.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError21 = false;
            //     this.state.addData.LengthOverall = this.state.addData.LengthOverall.trim();
            //     this.setState({})
            // }
            // if (Status.trim() === "") {
            //     this.state.isError22 = true;
            //     this.state.addData.Status = this.state.addData.Status;
            //     this.setState({})
            // }
            // else {
            //     this.state.isError22 = false;
            //     this.state.addData.Status = this.state.addData.Status;
            //     this.setState({})
            // }
            // if (InspectionLocation.trim() === "") {
            //     this.state.isError23 = true;
            //     this.state.addData.InspectionLocation = this.state.addData.InspectionLocation.trim();
            //     this.setState({})
            // }
            // else {
            //     this.state.isError23 = false;
            //     this.state.addData.InspectionLocation = this.state.addData.InspectionLocation.trim();
            //     this.setState({})
            // }

            // if (this.state.addData.Status === "Completed") {
            //     if (this.state.addData.CompletionDate === "" || this.state.addData.CompletionDate === null) {
            //         this.state.isError24 = true;
            //         this.state.addData.CompletionDate = this.state.addData.CompletionDate;
            //         this.setState({})
            //     }
            //     else {
            //         this.state.isError24 = false;
            //         this.state.addData.CompletionDate = this.state.addData.CompletionDate;
            //         this.setState({})
            //     }
            // }
            // if (this.state.addData.ShipType !== "" && this.state.addData.PortOfRegistry !== "" && this.state.addData.Breath !== 0 && this.state.addData.CallSign !== "" && this.state.addData.Class !== ""
            //     && this.state.addData.DeadWeight !== 0 && this.state.addData.DeliveryDate !== "" && this.state.addData.Depth !== 0 && this.state.addData.Flag !== "" && this.state.addData.GrossTonnage !== 0
            //     && this.state.addData.InspectionLocation !== "" && this.state.addData.LengthOverall !== 0 && this.state.addData.LightWeight !== "" && this.state.addData.ManagementAS !== "" && this.state.addData.Mmsi !== ""
            //     && this.state.addData.NetTonnage !== 0 && this.state.addData.PreviousName !== "" && this.state.addData.RegisteredOwner !== "" && this.state.addData.ShipBuilder !== "" && (this.state.addData.Status != "Completed" || (this.state.addData.Status === "Completed" && this.state.addData.CompletionDate != null))) {

            // }
            this.state.addData.ShipType = shipTypeValue;
            this.state.addData.ShipId = parseInt(localStorage.getItem("DashId"));
            this.state.addData.InspectionId = parseInt(localStorage.getItem("InspectionId"));
            this.state.addData.SectionId = parseInt(inspectionSystem.Vesselparticulars);
            this.setState({})
            if (this.state.addData.Id === 0) {
                this.addshipinfo(this.state.addData);
                this.setState({ cancel: false })
                localStorage.setItem("EditID", this.state.addData.Id)
                this.props.dispatch({ type: "CANCEL", data: false });
            }
            else {
                this.setState({ cancel: false })
                this.props.dispatch({ type: "CANCEL", data: false });
                this.putshipinfo(this.state.addData, this.state.addData.Id);
            }
        }
    };
    addshipinfo = (data) => {
        this.state.addData.ModifiedBy = "";
        this.state.addData.CreatedBy = localStorage.getItem("UserRoles");
        this.setState({});
        let apiUrl = API.AddEdit_Vessel;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
               
                if (response?.status === 200) {
                    this.state.addData.Id = response.data
                    this.setState({})
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                      //successAlert("Data saved successfully.");
            successToast();
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                // warningAlert("Something went wrong. Please try again.");
       errorToast();
       this.props.dispatch({ type: "CANCEL", data: true });
                if (error?.response?.status === 401) {
                }
            });
    };
    putshipinfo = (data, id) => {
        this.state.addData.ModifiedBy = localStorage.getItem("UserRoles");
        this.state.addData.CreatedBy = "";
        let apiUrl = `${API.AddEdit_Vessel}?id=${id}`;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
               
                if (response?.status === 200) {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                      //successAlert("Data saved successfully.");
            successToast();
                    // this.props.navigate("inspection/vesselparticular")
                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                // warningAlert("Something went wrong. Please try again.");
       errorToast();
       this.props.dispatch({ type: "CANCEL", data: true });
                if (error?.response?.status === 401) { }
            });

    };



    render() {
        const { classes, menuToggle, shipType, statusType } = this.props;
        const { isError1, isError2, isError3, isError4, isError5, isError6, isError7, isError8, isError9, isError10, isError11, isError12, isError13, isError14, isError15, isError16,
            isError17, isError18, isError19, isError20, isError21, isError22, isError23, isError24, addData, isEdit } = this.state;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4 mob-topfixed ">
                                <div className="col-7 mt-auto">
                                    <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar}>
                                            <ListItemText
                                                id={"VSP" + "1"}
                                                className="  textNaviIcon"
                                                primary="Inspection Tasks"
                                            />
                                            <NavigateNextIcon
                                                id="VSP"
                                                className="naviIcon ml-1"
                                                style={{ width: 23, height: 23 }}
                                            />
                                            <Divider className="border-bottom" />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-5 pt-2 mt-5">
                                    <h4 className="pt-2">Vessel Particulars</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide mt-138" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -75 }}>
                    {
                        this.state.isMobile ?
                            <table className="dataTable border-top" width="100%">
                                <tbody>
                                    <tr>
                                        <td className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                        <td className="border-right text-center" >
                                            <button className={`${classes.button}`} onClick={() => { this.Save() }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        </td>
                                        <td className="text-center">
                                            <button className={`${classes.button} `} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            :
                            <>
                                <table className="dataTable" width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                            <td className="" width="95%">
                                                <button className={`${classes.button}`} onClick={() => this.Save()}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                                <button className={`${classes.button} pl-3`} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table></>}
                    <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        {this.state.isMobile ? (
                            ""
                        ) : (
                            <h6 className="col-12 mx-2 mt-3 ml-1">Vessel Particulars</h6>
                        )}
                        <div className={this.state.isMobile ? "row mx-0 mt-2 mb-4" : "row mx-1 px-3 mt-2 mb-4"}>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-0 d-flex float-end text-right"}>Ship Name &nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        disabled="true"
                                        fullWidth
                                        value={localStorage.getItem("ShipName") && localStorage.getItem("ShipName")}
                                        InputProps={{
                                            className: `border-radius view-color ${classes.inputfieldAlign}`, style: { fontSize: 12 }
                                        }}
                                        classes={{ root: classes.helperText }}
                                    />
                                </div>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>Management  AS&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained mr-0">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError1 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.ManagementAS && this.state.addData.ManagementAS}
                                            onChange={(e) => { this.handleInputChange(e, "ManagementAS") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.ManagementAS && this.state.addData.ManagementAS}
                                        onChange={(e) => { this.handleInputChange(e, "ManagementAS") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-0 d-flex float-end text-right"}>Breadth&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError2 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.Breath && this.state.addData.Breath}
                                            onChange={(e) => { this.handleInputChange(e, "Breath") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }

                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.Breath && this.state.addData.Breath}
                                        onChange={(e) => { this.handleInputChange(e, "Breath") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n2 d-flex float-end text-right"} >Previous Name&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError3 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.PreviousName && this.state.addData.PreviousName}
                                            onChange={(e) => { this.handleInputChange(e, "PreviousName") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.PreviousName && this.state.addData.PreviousName}
                                        onChange={(e) => { this.handleInputChange(e, "PreviousName") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>Technical Manager&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError4 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.TechnicalManager && this.state.addData.TechnicalManager}
                                            onChange={(e) => { this.handleInputChange(e, "TechnicalManager") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.TechnicalManager && this.state.addData.TechnicalManager}
                                        onChange={(e) => { this.handleInputChange(e, "TechnicalManager") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-0 d-flex float-end text-right"}>Depth&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError5 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.Depth && this.state.addData.Depth}
                                            onChange={(e) => { this.handleInputChange(e, "Depth") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.Depth && this.state.addData.Depth}
                                        onChange={(e) => { this.handleInputChange(e, "Depth") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>IMO Number&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>

                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        disabled="true"
                                        value={localStorage.getItem("IMONumber") && localStorage.getItem("IMONumber")}
                                        InputProps={{
                                            className: `border-radius view-color ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                        classes={{ root: classes.helperText }}
                                    />
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>Ship Builder&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError6 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.ShipBuilder && this.state.addData.ShipBuilder}
                                            onChange={(e) => { this.handleInputChange(e, "ShipBuilder") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.ShipBuilder && this.state.addData.ShipBuilder}
                                        onChange={(e) => { this.handleInputChange(e, "ShipBuilder") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-0 d-flex float-end text-right"}>Summer&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError7 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.Summer && this.state.addData.Summer}
                                            onChange={(e) => { this.handleInputChange(e, "Summer") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.Summer && this.state.addData.Summer}
                                        onChange={(e) => { this.handleInputChange(e, "Summer") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>Port of Registry&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError8 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.PortOfRegistry && this.state.addData.PortOfRegistry}
                                            onChange={(e) => { this.handleInputChange(e, "PortOfRegistry") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.PortOfRegistry && this.state.addData.PortOfRegistry}
                                        onChange={(e) => { this.handleInputChange(e, "PortOfRegistry") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0 vp-required-label" : "m-n1 d-flex float-end text-right vp-required-label"}>Delivery Date&nbsp;:
                                        <span className="vp-required-asterisk">*</span>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        className="vp-delivery-date-field"
                                        type="date"
                                        id="vp-delivery-date"
                                        error={isError9}
                                        value={this.getDeliveryDateValue()}
                                        placeholder={this.getDeliveryDatePlaceholder()}
                                        onChange={(e) => { this.handleInputChange(e, "DeliveryDate") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 },
                                        }}
                                        inputProps={{
                                            className: this.getDeliveryDateValue() ? "has-value" : "",
                                            "data-display": this.getDeliveryDateDisplay(),
                                        }}
                                    />
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>Call Sign&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError10 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.CallSign && this.state.addData.CallSign}
                                            onChange={(e) => { this.handleInputChange(e, "CallSign") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.CallSign && this.state.addData.CallSign}
                                        onChange={(e) => { this.handleInputChange(e, "CallSign") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0 vp-required-label" : "m-n1 d-flex float-end text-right vp-required-label"}>Ship Type&nbsp;:
                                        <span className="vp-required-asterisk">*</span>
                                    </label>
                                </div>

                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3 vp-shiptype-field ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <>
                                        <select
                                            fullWidth
                                            value={this.state.addData?.ShipType && this.state.addData?.ShipType}
                                            style={{ height: "40px" }}
                                            className={`form-control border-radius vp-shiptype-select${isError11 ? " is-invalid" : ""}`}
                                            onChange={(e) => { this.handleInputChange(e, "ShipType") }}
                                        >
                                            <option value={0}>Select Ship Type</option>
                                            {shipType &&
                                                shipType.map((type, index) => (
                                                    <option key={type.Id || index} value={type.Id}>{type.Name}</option>
                                                ))}
                                        </select>
                                    </>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>Dead Weight&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError12 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.DeadWeight && this.state.addData.DeadWeight}
                                            onChange={(e) => { this.handleInputChange(e, "DeadWeight") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.DeadWeight && this.state.addData.DeadWeight}
                                        onChange={(e) => { this.handleInputChange(e, "DeadWeight") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>MMSI&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError13 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.Mmsi && this.state.addData.Mmsi}
                                            onChange={(e) => { this.handleInputChange(e, "Mmsi") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.Mmsi && this.state.addData.Mmsi}
                                        onChange={(e) => { this.handleInputChange(e, "Mmsi") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>Flag&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError14 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.Flag && this.state.addData.Flag}
                                            onChange={(e) => { this.handleInputChange(e, "Flag") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.Flag && this.state.addData.Flag}
                                        onChange={(e) => { this.handleInputChange(e, "Flag") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>Gross Tonnage&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError15 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.GrossTonnage && this.state.addData.GrossTonnage}
                                            onChange={(e) => { this.handleInputChange(e, "GrossTonnage") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.GrossTonnage && this.state.addData.GrossTonnage}
                                        onChange={(e) => { this.handleInputChange(e, "GrossTonnage") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>TEU&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError16 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.Teu && this.state.addData.Teu}
                                            onChange={(e) => { this.handleInputChange(e, "Teu") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.Teu && this.state.addData.Teu}
                                        onChange={(e) => { this.handleInputChange(e, "Teu") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>Class&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError17 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.Class && this.state.addData.Class}
                                            onChange={(e) => { this.handleInputChange(e, "Class") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.Class && this.state.addData.Class}
                                        onChange={(e) => { this.handleInputChange(e, "Class") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>Net Tonnage&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError18 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.NetTonnage && this.state.addData.NetTonnage}
                                            onChange={(e) => { this.handleInputChange(e, "NetTonnage") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.NetTonnage && this.state.addData.NetTonnage}
                                        onChange={(e) => { this.handleInputChange(e, "NetTonnage") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>Light Weight&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError19 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.LightWeight && this.state.addData.LightWeight}
                                            onChange={(e) => { this.handleInputChange(e, "LightWeight") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.LightWeight && this.state.addData.LightWeight}
                                        onChange={(e) => { this.handleInputChange(e, "LightWeight") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>Registered Owner&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError20 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.RegisteredOwner && this.state.addData.RegisteredOwner}
                                            onChange={(e) => { this.handleInputChange(e, "RegisteredOwner") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.RegisteredOwner && this.state.addData.RegisteredOwner}
                                        onChange={(e) => { this.handleInputChange(e, "RegisteredOwner") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>Length Overall&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError21 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.LengthOverall && this.state.addData.LengthOverall}
                                            onChange={(e) => { this.handleInputChange(e, "LengthOverall") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.LengthOverall && this.state.addData.LengthOverall}
                                        onChange={(e) => { this.handleInputChange(e, "LengthOverall") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>Inspection Location&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div> */}
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {/* {isError23 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.InspectionLocation && this.state.addData.InspectionLocation}
                                            onChange={(e) => { this.handleInputChange(e, "InspectionLocation") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                        /> : */}
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.InspectionLocation && this.state.addData.InspectionLocation}
                                        onChange={(e) => { this.handleInputChange(e, "InspectionLocation") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            style: { fontSize: 12 }
                                        }}
                                    />
                                    {/* } */}
                                </div>
                                {/* <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>Status&nbsp;:
                                        {/* <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <>
                                        {/* {isError22 ?
                                            <FormControl error fullWidth>
                                                <select
                                                    fullWidth
                                                    className="demo-customized-select"
                                                    value={this.state.addData?.Status && this.state.addData?.Status}
                                                    style={{ height: "40px", borderColor: "red", paddingLeft: "10px" }}
                                                    variant="outlined"
                                                    onChange={(e) => { this.handleInputChange(e, "Status") }}
                                                >
                                                    <option value={0}>Select Status</option>
                                                    {statusType && statusType?.map((item, index) => (
                                                        <option value={item.Name}>{item.Name}</option>
                                                    ))}
                                                </select>
                                            </FormControl> : 
                                            <select
                                                fullWidth
                                                className="form-control border-radius demo-customized-select"
                                                value={this.state.addData?.Status && this.state.addData?.Status}
                                                style={{ height: "40px" }}
                                                onChange={(e) => { this.handleInputChange(e, "Status") }}
                                            >
                                                <option value={0}>Select Status</option>
                                                {statusType && statusType?.map((item, index) => (
                                                    <option value={item.Name}>{item.Name}</option>
                                                ))}
                                            </select>
                                            {/* } 
                                    </>
                                </div> */}
                            </div>
                            {/* <div className={`row mx-1 align-items-center mb-3 ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}> */}
                            {/* <div id="completeddate" className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "} ${localStorage.getItem("Status") ===  "Completed" ? "d-block" : "d-none"}`} >
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 d-flex float-end text-right"}>Inspection Completed Date&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div id="completeddate1" className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}  ${localStorage.getItem("Status") === "Completed" ? "d-block" : "d-none"}`} >
                                    {isError24 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="date"
                                            id="type-date"
                                            error
                                            value={this.state.addData.CompletionDate && moment(this.state.addData.CompletionDate).format("yyyy-MM-DD") != "0001-00-01" && moment(this.state.addData.CompletionDate).format("yyyy-MM-DD") != "0001-01-01" && moment(this.state.addData.CompletionDate).format("yyyy") != "0001" && moment(this.state.addData.CompletionDate).format("yyyy-MM-DD")}
                                            placeholder={this.state.addData.CompletionDate && moment(this.state.addData.CompletionDate).format("yyyy-MM-DD") != "0001-00-01" && moment(this.state.addData.CompletionDate).format("yyyy-MM-DD") != "0001-01-01" && moment(this.state.addData.CompletionDate).format("yyyy") != "0001" ? moment(this.state.addData.CompletionDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY") : ""}
                                            onChange={(e) => { this.handleInputChange(e, "CompletionDate") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="date"
                                            id="type-date"
                                            value={this.state.addData.CompletionDate && moment(this.state.addData.CompletionDate).format("yyyy-MM-DD") != "0001-00-01" && moment(this.state.addData.CompletionDate).format("yyyy-MM-DD") != "0001-01-01" && moment(this.state.addData.CompletionDate).format("yyyy") != "0001" && moment(this.state.addData.CompletionDate).format("yyyy-MM-DD")}
                                            placeholder={this.state.addData.CompletionDate && moment(this.state.addData.CompletionDate).format("yyyy-MM-DD") != "0001-00-01" && moment(this.state.addData.CompletionDate).format("yyyy-MM-DD") != "0001-01-01" && moment(this.state.addData.CompletionDate).format("yyyy") != "0001" ? moment(this.state.addData.CompletionDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY") : ""}
                                            onChange={(e) => { this.handleInputChange(e, "CompletionDate") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                style: { fontSize: 12 }
                                            }}
                                        />
                                        }
                                </div> */}
                            {/* </div> */}
                        </div>
                        <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                            <div class="modal-dialog" role="document">
                                <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                    <div class="modal-body pb-0">
                                        <h1 className="text-center">
                                            <img src={del}></img>
                                        </h1>
                                        <div className="text-center">
                                            <h5 class="fw-bold">Changes are not saved yet. The data will be lost. Do you really want to cancel?</h5> </div>
                                    </div>
                                    <div class="modal-footer border-top-0 m-auto" data-dismiss="modal">
                                        <button type="button" class={this.state.isMobile ? "btn btn-secondary" : "btn btn-secondary py-2 px-4"} data-bs-toggle="modal" style={{ backgroundColor: "#499AC8", border: "none" }} onClick={this.AddCancel}><span className="" >Yes</span></button>
                                        <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : "btn btn-secondary py-2 px-4"} data-bs-dismiss="modal" onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                            <div class="modal-dialog" role="document">
                                <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                    <div class="modal-body pb-0">
                                        <h1 className="text-center">
                                            <img src={del}></img>
                                        </h1>
                                        <div className="text-center">
                                            <h5 class="fw-bold">Changes are not saved yet. The data will be lost. Do you really want to cancel?</h5> </div>
                                    </div>
                                    <div class="modal-footer border-top-0 m-auto">
                                        <button type="button" className={this.state.isMobile ? "btn btn-secondary" : "btn btn-secondary py-2 px-4"} data-bs-toggle="modal" style={{ backgroundColor: "#499AC8", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                        <button type="button" id="closemodal1" className={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-bs-dismiss="modal" onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        settings: state.commonReducer.settings || [],
        shipType: state.lookupReducer.shipType || [],
        statusType: state.lookupReducer.statusType || []

    };
}

AddEditVP.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddEditVP))
);